import { Component, QntmConfigurationActionTypes, QntmConfigurationActions, QntmSystemConfiguration } from './ShopQntmSystemConfigurationModel'

export const addComponent = (component: Component): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.AddComponent,
  payload: component,
})

export const removeComponent = (componentId: string): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.RemoveComponent,
  payload: componentId,
})

export const addProduct = (componentId: string, productId: string, qty: number): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.AddProduct,
  payload: {
    componentId,
    productId,
    qty,
  },
})

export const removeProduct = (componentId: string, productId: string): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.RemoveProduct,
  payload: {
    componentId,
    productId,
  },
})

export const increaseQuantity = (componentId: string, productId: string): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.IncreaseQuantity,
  payload: {
    componentId,
    productId,
  },
})

export const decreaseQuantity = (componentId: string, productId: string): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.DecreaseQuantity,
  payload: {
    componentId,
    productId,
  },
})

export const setQuantity = (quantity: number): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.SetQuantity,
  payload: quantity,
})

export const updateLabel = (label: string): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.UpdateLabel,
  payload: label,
})

export const setShippingDate = (day: number, month: number, year: number): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.SetShippingDate,
  payload: { day, month, year },
})

export const updateConfiguratorId = (configuratorId: string | null): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.SetConfiguratorId,
  payload: configuratorId,
})

export const addWarrantyExtension = (id: string): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.AddWarrantyExtension,
  payload: { id },
})

export const removeWarrantyExtension = (): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.RemoveWarrantyExtension,
})

export const addConfigurator = (configurator: QntmSystemConfiguration): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.AddConfigurator,
  payload: configurator,
})

export const resetConfigurator = (): QntmConfigurationActions => ({
  type: QntmConfigurationActionTypes.ResetConfigurator,
})
